import CheckRounded from "@mui/icons-material/CheckRounded";
import { Box, CircularProgress, IconButton, styled } from "@mui/material";
import AccentColor from "datasets/types/enums/accent-color";
import ColorCircle from "./ColorCircle";

const ColorRadio = ({
  disabled = false,
  loading = false,
  onClick,
  selected = false,
  showCheck = false,
  value,
}: {
  disabled?: boolean;
  loading?: boolean;
  onClick: (color: AccentColor) => void;
  selected?: boolean;
  showCheck?: boolean;
  value: AccentColor;
}) => {
  return (
    <IconButton
      disabled={disabled}
      onClick={() => onClick(value)}
      sx={{
        borderColor: selected ? "grey.400" : "transparent", // Border shows immediately
        borderRadius: 1.5,
        borderStyle: "solid",
        borderWidth: 1,
        color: "common.white",
        p: 0.75,
        "&.Mui-disabled": {
          opacity: selected ? "unset" : 0.3,
        },
      }}
    >
      <ColorCircle sx={{ backgroundColor: value }} />
      {/* Show loading spinner OR check mark based on state */}
      {loading ? (
        <CircularProgress size={16} sx={{ color: "inherit", position: "absolute" }} />
      ) : (
        showCheck && <CheckRounded sx={{ color: "inherit", position: "absolute", width: 16 }} />
      )}
    </IconButton>
  );
};

export default ColorRadio;
